module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Share-aae39aba2cfc3ca6ab375fb40a628451.svg";